{
    "Profile_Dwellings_SwimmingPool.swimmingPool": "Swimming Pool",
    "Profile_Dwellings_SwimmingPool.swimmingPoolDetails": "Swimming Pool Details",
    "Profile_Dwellings_SwimmingPool.type": "Type",
    "Profile_Dwellings_SwimmingPool.construction": "Construction",
    "Profile_Dwellings_SwimmingPool.condition": "Condition",
    "Profile_Dwellings_SwimmingPool.approvedFence": "Approved Fence"
}
